import { render, staticRenderFns } from "./ApiMessage.vue?vue&type=template&id=6748b346"
import script from "./ApiMessage.vue?vue&type=script&lang=js"
export * from "./ApiMessage.vue?vue&type=script&lang=js"
import style0 from "./ApiMessage.vue?vue&type=style&index=0&id=6748b346&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports